(function () {
  angular
    .module("akitabox.serviceRequest.create")
    .controller(
      "CreateServiceRequestController",
      CreateServiceRequestController
    );

  /* @ngInject */
  function CreateServiceRequestController(
    $timeout,
    $scope,
    // Third party
    $state,
    // Services
    AssetService,
    FloorService,
    IssueTypeService,
    PinValueService,
    RequestService,
    RoomService,
    ShadowService,
    ToastService,
    // Models
    account,
    building,
    // Route params
    floorId,
    roomId,
    assetId
  ) {
    var self = this;

    // Constants
    var GA_CATEGORY = "servicerequest-modal";
    var GA_SUBMIT_ACTION = "submit-service-request";
    var GA_ATTACHMENT_ACTION = "attachments-add";

    // Private Attributes
    var issueTypesRequest;

    // Attributes
    self.saving = false;
    self.successful = false;
    self.activeTab = 0;
    self.tabs = null;

    // Location tab variables
    self.account = account;
    self.building = building;
    self.buildingAccount = null;
    self.floor = null;
    self.room = null;
    self.asset = null;

    // Description tab variables
    self.subject = null;
    self.issueType = null;
    self.description = null;
    self.issueTypes = null;
    self.attachments = [];

    // Functions
    self.createRequest = createRequest;
    self.next = next;
    self.previous = previous;
    self.selectTab = selectTab;
    self.isComplete = isComplete;
    self.querySearch = querySearch;
    self.handleFilesChange = handleFilesChange;

    init();

    // ------------------------
    //   Private Functions
    // ------------------------

    function init() {
      // Watch building
      $scope.$watch("vm.building", function (building) {
        if (!building) return;

        self.issueType = null;
        // Fetch issue types
        if (!building.show_issue_types) return;
        self.fetchingIssueTypes = true;
        issueTypesRequest = IssueTypeService.getAll(building._id)
          .then(function (issueTypes) {
            self.issueTypes = issueTypes;

            if (angular.isEmpty(self.searchText)) return issueTypes;
            return filterQuery(self.searchText, issueTypes);
          })
          .catch(ToastService.showError)
          .finally(function () {
            self.fetchingIssueTypes = false;
          });
      });

      // Handle any URL parameters that were passed in
      // so we can autofill the fields.
      // Building is required to autofill any query param
      if (angular.isEmpty(self.building)) {
        self.tabs = getTabs();
        return;
      }

      if (!angular.isEmpty(assetId)) {
        AssetService.getById(building._id, assetId, { include_values: true })
          .then(function (asset) {
            // Just grab the name and ID of the floor and room, since that's all we need.
            // This way, we don't need to make another request since they're in the asset's
            // included values
            var floorPinValue = PinValueService.getFloorPinValue(asset.values);
            if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
              self.floor = {
                _id: floorPinValue.value,
                name: floorPinValue.name,
              };
            }
            var roomPinValue = PinValueService.getRoomPinValue(asset.values);
            if (roomPinValue && !angular.isEmpty(roomPinValue.value)) {
              self.room = {
                _id: roomPinValue.value,
                name: roomPinValue.name,
              };
            }

            self.asset = asset;
          })
          .then(function () {
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else if (!angular.isEmpty(roomId)) {
        RoomService.getById(building._id, roomId, { include_values: true })
          .then(function (room) {
            // Just grab the name and ID of the floor, since that's all we need.
            // This way, we don't need to make another request since it's in the room's
            // included values
            var floorPinValue = PinValueService.getFloorPinValue(room.values);
            if (floorPinValue && !angular.isEmpty(floorPinValue.value)) {
              self.floor = {
                _id: floorPinValue.value,
                name: floorPinValue.name,
              };
            }
            self.room = room;
          })
          .then(function () {
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else if (!angular.isEmpty(floorId)) {
        FloorService.getById(building._id, floorId)
          .then(function (floor) {
            self.floor = floor;
          })
          .then(function () {
            self.tabs = getTabs();
          })
          .catch(ToastService.showError);
      } else {
        self.tabs = getTabs();
      }
    }

    /**
     * Retrieve list of tabs
     *
     * @return {Array} List of tabs
     */
    function getTabs() {
      return [
        {
          title: "Location",
          disabled: isLocationDisabled,
          complete: isLocationComplete,
          template:
            "app/mobile/modules/service-request/create/tabs/location.html",
        },
        {
          title: "Description",
          disabled: isDescriptionDisabled,
          complete: isDescriptionComplete,
          template:
            "app/mobile/modules/service-request/create/tabs/description.html",
        },
      ];
    }

    function isLocationComplete() {
      return !angular.isEmpty(self.building);
    }

    function isLocationDisabled() {
      return false;
    }

    function isDescriptionComplete() {
      return (
        !isLocationDisabled() &&
        !angular.isEmpty(self.subject) &&
        (!angular.isEmpty(self.issueType) ||
          !self.building.require_issue_types) &&
        allUploadsComplete()
      );
    }

    function isDescriptionDisabled() {
      return !isLocationComplete();
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    function next() {
      if (self.activeTab === 2) return;
      self.selectTab(self.activeTab + 1);
    }

    function previous() {
      if (self.activeTab === 0) return;
      self.selectTab(self.activeTab - 1);
    }

    /**
     * Select a tab
     *
     * @param  {Number} idx Tab index
     */
    function selectTab(idx) {
      self.activeTab = idx;
    }

    function isComplete() {
      var complete = true;
      angular.forEach(self.tabs, function (tab) {
        complete = complete && tab.complete();
      });
      return complete;
    }

    /**
     * Create the service request
     */
    function createRequest($event) {
      if (self.saving || self.successful) {
        if ($event) $event.preventDefault();
        return;
      }

      self.saving = true;

      // Create local data object and populate with contents set by user
      var data = {
        subject: self.subject,
        status: "new",
        description: self.description,
        issue_type: self.issueType,
        requester_email: self.account.email,
      };

      if (!angular.isEmpty(self.floor)) data.floor = self.floor._id;
      if (!angular.isEmpty(self.room)) data.room = self.room._id;
      if (!angular.isEmpty(self.asset)) data.asset = self.asset._id;
      if (self.attachments.length > 0) {
        data.attachments = self.attachments.map(function (attachment) {
          return attachment._document._id;
        });
      }

      ShadowService.sendEvent(GA_CATEGORY, GA_SUBMIT_ACTION);
      ShadowService.sendEvent(
        GA_CATEGORY,
        GA_ATTACHMENT_ACTION,
        "",
        self.attachments.length
      );

      RequestService.create(self.building._id, data)
        .then(function (request) {
          self.saving = false;
          self.successful = true;
          return $timeout(function () {
            return request;
          }, 500);
        })
        .then(function (request) {
          // Navigate to the details of the service request
          $state.go("app.building.serviceRequest.detail", {
            buildingId: self.building._id,
            requestId: request._id,
            request: request,
          });
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.saving = false;
        });
    }

    function querySearch(searchText) {
      if (self.issueTypes) {
        if (angular.isEmpty(searchText)) return self.issueTypes;
        return filterQuery(searchText, self.issueTypes);
      }

      // Still fetching issue types; return pending request
      return issueTypesRequest;
    }

    function filterQuery(searchText, matches) {
      return matches.filter(function (match) {
        return match.name.match(new RegExp(searchText, "i"));
      });
    }

    function handleFilesChange(files) {
      self.attachments = files;
    }

    function allUploadsComplete() {
      return self.attachments.reduce(function (prev, current) {
        return prev && current.complete;
      }, true);
    }
  }
})();
